module.exports = __webpack_public_path__ + "static/media/TvShowBanner (8).b85b953e.png";